module.exports = __webpack_public_path__ + "media/images/page/top/top_img_09-2b601f89e28fbf38d6f7459c3444b823.png";